import React from "../../__snowpack__/pkg/react.js";
import {Input} from "../../__snowpack__/pkg/antd.js";
import {omit, pick} from "../../__snowpack__/pkg/lodash.js";
import styled from "../../__snowpack__/pkg/styled-components.js";
export const InputLimit = (props) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className: "input-limit",
    ...omit(props, ["value", "onChange", "limit", "inputProps"])
  }, /* @__PURE__ */ React.createElement(Input, {
    ...pick(props, ["value", "onChange", "maxLength", "disabled"]),
    ...props.inputProps,
    suffix: /* @__PURE__ */ React.createElement("div", {
      className: "limit-title"
    }, (props.value || "").length, "/", props.limit)
  }));
};
const Wrapper = styled.div`
  &.input-limit {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;
  }
  .limit-title {
    margin-left: 8px;
    font-size: 12px;
    font-family: SFProText-Regular, SFProText;
    font-weight: 400;
    color: #7f8fa4;
    line-height: 14px;
  }
`;
